/**
 * Review moderation scenarios — canonical dataset for Reviews list / detail and queue.
 * Aligned to Trades Poster — Reviews Screen 1 samples and Screen 2 Overview data.
 */
const BASE = new Date('2026-08-05T00:00:00.000Z');

const reviewScenarios = [
  // Screen 1 sample — RVW-9102 (Under Review, Replied, 2 open System Flags)
  {
    scenarioKey: 1,
    name: 'System Flag — Customer Review and Business Reply',
    review: {
      reviewId: 'RVW-9102',
      id: 'rvw-9102',
      rating: 4,
      status: 'Under Review',
      fullText:
        'Apex Plumbing replied quickly, arrived when arranged and repaired the leaking kitchen tap. The area was left clean and the final cost matched what we discussed.',
      attachments: [
        'https://picsum.photos/seed/plumbing1/640/480',
        'https://picsum.photos/seed/plumbing2/640/480',
      ],
      postedAt: '2026-08-05T14:15:00+10:00',
      lastUpdated: '2026-08-05T16:45:00+10:00',
      editUntil: '2026-09-04T14:15:00+10:00',
      reviewer: {
        name: 'Sarah Kerr',
        publicName: 'Sarah K.',
        id: 'CUS-2187',
        avatar: 'https://i.pravatar.cc/150?img=47',
        status: 'Active',
        verificationStatus: 'Verified',
        memberSince: '2024-03-15T00:00:00.000Z',
      },
      business: {
        name: 'Apex Plumbing',
        id: 'BUS-5521',
        category: 'Plumbing',
        subcategory: 'Emergency Plumbing',
        state: 'VIC',
        suburb: 'Melbourne',
        verified: true,
        logo: 'https://i.pravatar.cc/150?img=65',
        memberSince: '2022-08-01T00:00:00.000Z',
        status: 'Active',
        responseStatus: 'Responded',
      },
      reply: {
        hasReply: true,
        status: 'Replied',
        replyId: 'RRP-000401',
        body: 'Thank you, Sarah. We appreciate the feedback and are glad the repair was completed as arranged.',
        timestamp: '2026-08-05T16:20:00+10:00',
        lastUpdated: '2026-08-05T16:45:00+10:00',
        editUntil: '2026-09-04T16:20:00+10:00',
      },
      interactionType: 'Quote',
      interactionId: 'QTE-4182',
    },
    flags: [
      {
        flagId: 'FLG-62001',
        source: 'System Flag',
        reviewTarget: 'Customer Review',
        category: 'Moderation',
        reason: 'Harassment / abusive language',
        trigger: 'Harassment / abusive language',
        severity: 'Medium',
        status: 'New',
        caseStatus: 'New',
        linkedCaseId: 'MOD-000721',
        createdAt: '2026-08-05T16:45:00+10:00',
        updatedAt: '2026-08-05T16:45:00+10:00',
      },
      {
        flagId: 'FLG-62002',
        source: 'System Flag',
        reviewTarget: 'Business Reply',
        category: 'Moderation',
        reason: 'Unprofessional wording',
        trigger: 'Unprofessional wording',
        severity: 'Low',
        status: 'New',
        caseStatus: 'New',
        linkedCaseId: 'MOD-000722',
        createdAt: '2026-08-05T16:45:00+10:00',
        updatedAt: '2026-08-05T16:45:00+10:00',
      },
    ],
    flag: {
      flagId: 'FLG-62001',
      source: 'System Flag',
      reviewTarget: 'Customer Review',
      category: 'Moderation',
      reason: 'Harassment / abusive language',
      trigger: 'Harassment / abusive language',
      severity: 'Medium',
      status: 'New',
      caseStatus: 'New',
      linkedCaseId: 'MOD-000721',
      createdAt: '2026-08-05T16:45:00+10:00',
      updatedAt: '2026-08-05T16:45:00+10:00',
    },
    case: {
      caseId: 'MOD-000721',
      contentType: 'Review',
      severity: 'Medium',
      status: 'New',
      assignedTo: 'Unassigned',
      created: '2026-08-05T16:45:00+10:00',
      updated: '2026-08-05T16:45:00+10:00',
    },
    replyCase: {
      caseId: 'MOD-000722',
      contentType: 'Business Reply',
      severity: 'Low',
      status: 'New',
      assignedTo: 'Unassigned',
      created: '2026-08-05T16:45:00+10:00',
      updated: '2026-08-05T16:45:00+10:00',
    },
    adminNote: null,
  },

  // Screen 1 sample — RVW-9103 (Published, Not Replied, no open flags)
  {
    scenarioKey: 2,
    name: 'Published Review — No Flags',
    review: {
      reviewId: 'RVW-9103',
      id: 'rvw-9103',
      rating: 5,
      status: 'Published',
      fullText:
        'Clear communication and arrived as arranged. The electrical work was neat and explained clearly.',
      attachments: [],
      postedAt: '2026-08-05T13:35:00+10:00',
      lastUpdated: '2026-08-05T13:35:00+10:00',
      editUntil: '2026-09-04T13:35:00+10:00',
      reviewer: {
        name: 'Daniel Morris',
        publicName: 'Daniel M.',
        id: 'CUS-3349',
        avatar: 'https://i.pravatar.cc/150?img=32',
        status: 'Active',
        verificationStatus: 'Verified',
        memberSince: '2023-08-01T00:00:00.000Z',
      },
      business: {
        name: 'Bright Spark Electrical',
        id: 'BUS-4412',
        category: 'Electrical',
        state: 'VIC',
        suburb: 'Melbourne',
        verified: true,
        logo: 'https://i.pravatar.cc/150?img=66',
        memberSince: '2023-05-12T00:00:00.000Z',
        status: 'Active',
      },
      reply: { hasReply: false, status: 'Not Replied' },
      interactionType: 'Message',
      interactionId: 'MSG-2201',
    },
    flags: [],
    flag: null,
    case: null,
    adminNote: null,
  },

  // Screen 1 sample — RVW-9104 (Under Review, Replied, 2 open System Flags)
  {
    scenarioKey: 3,
    name: 'System Flag — Review and Reply (second sample)',
    review: {
      reviewId: 'RVW-9104',
      id: 'rvw-9104',
      rating: 2,
      status: 'Under Review',
      fullText:
        'The agreed work took longer than expected and communication could have been clearer throughout.',
      attachments: [
        'https://picsum.photos/seed/review-kitchen/640/480',
        'https://picsum.photos/seed/review-bathroom/640/480',
      ],
      postedAt: '2026-08-04T18:20:00+10:00',
      lastUpdated: '2026-08-05T09:05:00+10:00',
      editUntil: '2026-09-03T18:20:00+10:00',
      reviewer: {
        name: 'Emily Rogers',
        publicName: 'Emily R.',
        id: 'CUS-2874',
        avatar: 'https://i.pravatar.cc/150?img=12',
        status: 'Active',
        verificationStatus: 'Verified',
        memberSince: '2024-01-10T00:00:00.000Z',
      },
      business: {
        name: 'Coastal Carpentry',
        id: 'BUS-5091',
        category: 'Carpentry',
        state: 'VIC',
        suburb: 'Geelong',
        verified: true,
        logo: 'https://i.pravatar.cc/150?img=67',
        memberSince: '2022-11-20T00:00:00.000Z',
        status: 'Active',
      },
      reply: {
        hasReply: true,
        status: 'Replied',
        replyId: 'RRP-000404',
        body: 'We are looking into this feedback and will follow up directly.',
        timestamp: '2026-08-04T20:30:00+10:00',
        lastUpdated: '2026-08-05T09:05:00+10:00',
        editUntil: '2026-09-03T20:30:00+10:00',
      },
      interactionType: 'Quote',
      interactionId: 'QTE-4305',
    },
    flags: [
      {
        flagId: 'FLG-62011',
        source: 'System Flag',
        reviewTarget: 'Customer Review',
        category: 'Moderation',
        reason: 'Misleading claims',
        trigger: 'Misleading claims',
        severity: 'Medium',
        status: 'New',
        caseStatus: 'New',
        linkedCaseId: 'MOD-000731',
        createdAt: '2026-08-05T09:05:00+10:00',
        updatedAt: '2026-08-05T09:05:00+10:00',
      },
      {
        flagId: 'FLG-62012',
        source: 'System Flag',
        reviewTarget: 'Business Reply',
        category: 'Moderation',
        reason: 'Unprofessional wording',
        trigger: 'Unprofessional wording',
        severity: 'Low',
        status: 'New',
        caseStatus: 'New',
        linkedCaseId: 'MOD-000732',
        createdAt: '2026-08-05T09:05:00+10:00',
        updatedAt: '2026-08-05T09:05:00+10:00',
      },
    ],
    flag: {
      flagId: 'FLG-62011',
      source: 'System Flag',
      reviewTarget: 'Customer Review',
      category: 'Moderation',
      reason: 'Misleading claims',
      trigger: 'Misleading claims',
      severity: 'Medium',
      status: 'New',
      caseStatus: 'New',
      linkedCaseId: 'MOD-000731',
      createdAt: '2026-08-05T09:05:00+10:00',
      updatedAt: '2026-08-05T09:05:00+10:00',
    },
    case: {
      caseId: 'MOD-000731',
      contentType: 'Review',
      severity: 'Medium',
      status: 'New',
      assignedTo: 'Unassigned',
      created: '2026-08-05T09:05:00+10:00',
      updated: '2026-08-05T09:05:00+10:00',
    },
    replyCase: {
      caseId: 'MOD-000732',
      contentType: 'Business Reply',
      severity: 'Low',
      status: 'New',
      assignedTo: 'Unassigned',
      created: '2026-08-05T09:05:00+10:00',
      updated: '2026-08-05T09:05:00+10:00',
    },
    adminNote: null,
  },

  // Screen 1 sample — RVW-9105 (Hidden, Not Replied, 1 open System Flag)
  {
    scenarioKey: 4,
    name: 'Hidden Review — Open System Flag',
    review: {
      reviewId: 'RVW-9105',
      id: 'rvw-9105',
      rating: 3,
      status: 'Hidden',
      fullText: 'The finish was uneven in several areas and required a follow-up visit.',
      attachments: ['https://picsum.photos/seed/painting-finish/640/480'],
      postedAt: '2026-08-03T11:10:00+10:00',
      lastUpdated: '2026-08-04T15:25:00+10:00',
      editUntil: '2026-09-02T11:10:00+10:00',
      reviewer: {
        name: 'Michael Turner',
        publicName: 'Michael T.',
        id: 'CUS-4419',
        avatar: 'https://i.pravatar.cc/150?img=10',
        status: 'Active',
        verificationStatus: 'Verified',
        memberSince: '2023-11-20T00:00:00.000Z',
      },
      business: {
        name: 'Premier Painting',
        id: 'BUS-6027',
        category: 'Painting',
        state: 'VIC',
        suburb: 'Melbourne',
        verified: true,
        logo: 'https://i.pravatar.cc/150?img=68',
        memberSince: '2023-02-15T00:00:00.000Z',
        status: 'Active',
      },
      reply: { hasReply: false, status: 'Not Replied' },
      interactionType: 'Quote',
      interactionId: 'QTE-4411',
    },
    flags: [
      {
        flagId: 'FLG-62021',
        source: 'System Flag',
        reviewTarget: 'Customer Review',
        category: 'Moderation',
        reason: 'Suspected retaliatory review',
        trigger: 'Suspected retaliatory review',
        severity: 'Medium',
        status: 'Active',
        caseStatus: 'Active',
        linkedCaseId: 'MOD-000741',
        createdAt: '2026-08-04T15:25:00+10:00',
        updatedAt: '2026-08-04T15:25:00+10:00',
      },
    ],
    flag: {
      flagId: 'FLG-62021',
      source: 'System Flag',
      reviewTarget: 'Customer Review',
      category: 'Moderation',
      reason: 'Suspected retaliatory review',
      trigger: 'Suspected retaliatory review',
      severity: 'Medium',
      status: 'Active',
      caseStatus: 'Active',
      linkedCaseId: 'MOD-000741',
      createdAt: '2026-08-04T15:25:00+10:00',
      updatedAt: '2026-08-04T15:25:00+10:00',
    },
    case: {
      caseId: 'MOD-000741',
      contentType: 'Review',
      severity: 'Medium',
      status: 'Active',
      assignedTo: 'Alex Chen',
      created: '2026-08-04T15:25:00+10:00',
      updated: '2026-08-04T15:25:00+10:00',
    },
    adminNote: null,
  },

  // Screen 1 sample — RVW-9106 (Removed, Reply Deleted, 1 open System Flag)
  {
    scenarioKey: 5,
    name: 'Removed Review — Historical System Flag',
    review: {
      reviewId: 'RVW-9106',
      id: 'rvw-9106',
      rating: 1,
      status: 'Removed',
      fullText: 'The arranged attendance did not occur and no alternative time was offered.',
      attachments: [],
      postedAt: '2026-08-02T10:30:00+10:00',
      lastUpdated: '2026-08-04T12:15:00+10:00',
      editUntil: '2026-09-01T10:30:00+10:00',
      reviewer: {
        name: 'Laura Bennett',
        publicName: 'Laura B.',
        id: 'CUS-5184',
        avatar: 'https://i.pravatar.cc/150?img=28',
        status: 'Active',
        verificationStatus: 'Verified',
        memberSince: '2024-06-01T00:00:00.000Z',
      },
      business: {
        name: 'GreenLine Landscaping',
        id: 'BUS-7721',
        category: 'Landscaping',
        state: 'VIC',
        suburb: 'Melbourne',
        verified: true,
        logo: 'https://i.pravatar.cc/150?img=69',
        memberSince: '2021-03-10T00:00:00.000Z',
        status: 'Active',
      },
      reply: {
        hasReply: true,
        status: 'Deleted',
        replyId: 'RRP-000406',
        body: 'Thank you for sharing your experience. We have noted your comments.',
        timestamp: '2026-08-02T14:20:00+10:00',
        lastUpdated: '2026-08-04T12:15:00+10:00',
        editUntil: '2026-09-01T14:20:00+10:00',
      },
      interactionType: 'Message',
      interactionId: 'MSG-2318',
    },
    flags: [
      {
        flagId: 'FLG-62031',
        source: 'System Flag',
        reviewTarget: 'Customer Review',
        category: 'Moderation',
        reason: 'Fake or misleading review',
        trigger: 'Fake or misleading review',
        severity: 'High',
        status: 'Active',
        caseStatus: 'Active',
        linkedCaseId: 'MOD-000751',
        createdAt: '2026-08-04T12:15:00+10:00',
        updatedAt: '2026-08-04T12:15:00+10:00',
      },
    ],
    flag: {
      flagId: 'FLG-62031',
      source: 'System Flag',
      reviewTarget: 'Customer Review',
      category: 'Moderation',
      reason: 'Fake or misleading review',
      trigger: 'Fake or misleading review',
      severity: 'High',
      status: 'Active',
      caseStatus: 'Active',
      linkedCaseId: 'MOD-000751',
      createdAt: '2026-08-04T12:15:00+10:00',
      updatedAt: '2026-08-04T12:15:00+10:00',
    },
    case: {
      caseId: 'MOD-000751',
      contentType: 'Review',
      severity: 'High',
      status: 'Active',
      assignedTo: 'Alex Chen',
      created: '2026-08-04T12:15:00+10:00',
      updated: '2026-08-04T12:15:00+10:00',
    },
    adminNote: null,
  },

  // Screen 1 sample — RVW-9107 (Deleted by Customer, Replied, no open flags)
  {
    scenarioKey: 6,
    name: 'Customer-deleted Review',
    review: {
      reviewId: 'RVW-9107',
      id: 'rvw-9107',
      rating: 4,
      status: 'Deleted',
      fullText:
        'The repair was completed and explained clearly. Happy with the overall outcome.',
      attachments: [],
      postedAt: '2026-08-01T16:45:00+10:00',
      lastUpdated: '2026-08-05T08:10:00+10:00',
      editUntil: '2026-08-31T16:45:00+10:00',
      reviewer: {
        name: 'Robert Chen',
        publicName: 'Robert C.',
        id: 'CUS-6021',
        avatar: 'https://i.pravatar.cc/150?img=15',
        status: 'Active',
        verificationStatus: 'Verified',
        memberSince: '2024-02-01T00:00:00.000Z',
      },
      business: {
        name: 'ClearFlow Plumbing',
        id: 'BUS-8102',
        category: 'Plumbing',
        state: 'VIC',
        suburb: 'Melbourne',
        verified: true,
        logo: 'https://i.pravatar.cc/150?img=70',
        memberSince: '2022-01-15T00:00:00.000Z',
        status: 'Active',
      },
      reply: {
        hasReply: true,
        status: 'Replied',
        replyId: 'RRP-000407',
        body: 'Thanks Robert — glad we could help.',
        timestamp: '2026-08-01T18:00:00+10:00',
        lastUpdated: '2026-08-01T18:00:00+10:00',
        editUntil: '2026-08-31T18:00:00+10:00',
      },
      interactionType: 'Quote',
      interactionId: 'QTE-4060',
    },
    flags: [],
    flag: null,
    case: null,
    adminNote: null,
  },
];

/** Unique customers from review scenarios (for Admin Users > Customer Detail lookup) */
export function getCustomersFromReviewScenarios() {
  const seen = new Set();
  const now = new Date(BASE);
  return reviewScenarios
    .filter((s) => {
      const id = s.review.reviewer?.id || s.review.reviewer?.customerId;
      if (!id || seen.has(String(id).toLowerCase())) return false;
      seen.add(String(id).toLowerCase());
      return true;
    })
    .map((s, idx) => {
      const c = s.review.reviewer;
      const cid = c.id || c.customerId;
      const parts = (c.name || '').split(/\s+/);
      const joined = new Date(s.review.postedAt || s.case?.created || BASE);
      joined.setDate(joined.getDate() - (180 + idx * 60));
      const lastActive = new Date(now.getTime() - 2 * 24 * 60 * 60 * 1000);
      return {
        id: cid,
        customerId: cid,
        firstName: parts[0] || '',
        lastName: parts.slice(1).join(' ') || '',
        name: c.name,
        email: `customer.${String(cid || '').toLowerCase().replace(/^cus-?/i, '')}@example.com`,
        mobile: `0400 ${String(100000 + idx).slice(-6).replace(/(\d{3})(\d{3})/, '$1 $2')}`,
        region: 'VIC',
        location: { suburb: 'Melbourne', postcode: '3000' },
        status: c.status === 'Active' ? 'Active' : c.status || 'Active',
        flagCount: 0,
        underReview: false,
        flagged: false,
        joined: joined.toISOString().split('T')[0],
        lastLogin: lastActive.toISOString().split('T')[0],
        lastActive: lastActive.toISOString(),
        emailVerified: true,
        phoneVerified: true,
        profilePicture: c.avatar || `https://i.pravatar.cc/150?img=${47 + idx}`,
      };
    });
}

/** Unique businesses from review scenarios (for Admin Users > Business Detail lookup) */
export function getBusinessesFromReviewScenarios() {
  const seen = new Set();
  const now = new Date(BASE);
  return reviewScenarios
    .filter((s) => {
      const id = s.review.business?.id || s.review.business?.businessId;
      if (!id || seen.has(String(id).toLowerCase())) return false;
      seen.add(String(id).toLowerCase());
      return true;
    })
    .map((s, idx) => {
      const b = s.review.business;
      const bid = b.id || b.businessId;
      const joined = new Date(s.review.postedAt || s.case?.created || BASE);
      joined.setDate(joined.getDate() - (365 - idx * 30));
      return {
        id: bid,
        businessId: bid,
        businessName: b.name || b.businessName,
        mobile: `0412 ${String(600000 + idx).slice(-6).replace(/(\d{3})(\d{3})/, '$1 $2')}`,
        email: `contact.${String(bid || '').toLowerCase().replace(/^bus-?/i, '')}@example.com`,
        businessEmail: `contact.${String(bid || '').toLowerCase().replace(/^bus-?/i, '')}@example.com`,
        abn: `12${String(345678901 + idx).padStart(9, '0')}`,
        licenseNumber: `LIC${String(100100 + idx).padStart(6, '0')}`,
        location: { suburb: b.suburb || 'Melbourne', postcode: b.postcode || '3000' },
        region: b.state || 'VIC',
        category: b.category || 'Plumbing',
        primaryTrade: b.category || 'Plumbing',
        status: 'Active',
        plan: 'PRO',
        verificationStatus: b.verified ? 'verified' : 'verified',
        emailVerified: true,
        phoneVerified: true,
        joined: joined.toISOString().split('T')[0],
        lastLogin: new Date(now.getTime() - 2 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
        lastActive: new Date(now.getTime() - 2 * 24 * 60 * 60 * 1000).toISOString(),
        profilePicture: b.logo || `https://i.pravatar.cc/150?img=${65 + idx}`,
      };
    });
}

const caseIdDigits = (caseId) => String(caseId || '').replace(/^(?:MODS|MOA|MOD)-?/i, '');

/** Resolve Review or Business Reply case object on a scenario by Case ID. */
export function resolveReviewCaseRecord(scenario, caseId) {
  if (!scenario || !caseId) return null;
  const n = caseIdDigits(caseId);
  if (scenario.case && caseIdDigits(scenario.case.caseId) === n) return scenario.case;
  if (scenario.replyCase && caseIdDigits(scenario.replyCase.caseId) === n) {
    return scenario.replyCase;
  }
  return null;
}

export function getReviewScenarioByCaseId(caseId) {
  if (!caseId) return null;
  const n = caseIdDigits(caseId);
  return (
    reviewScenarios.find((s) => {
      if (s.case && caseIdDigits(s.case.caseId) === n) return true;
      if (s.replyCase && caseIdDigits(s.replyCase.caseId) === n) return true;
      return (s.flags || []).some((f) => caseIdDigits(f.linkedCaseId) === n);
    }) || null
  );
}

export function getReviewScenarioByReviewId(reviewId) {
  if (!reviewId) return null;
  const n = String(reviewId).replace(/^RVW-?/i, '');
  return (
    reviewScenarios.find(
      (s) =>
        String(s.review.reviewId).replace(/^RVW-?/i, '') === n ||
        String(s.review.id).replace(/^rvw-?/i, '') === n
    ) || null
  );
}

/** Moderation Queue — Low, Medium and High all create cases. */
const REVIEW_QUEUE_EXCLUDED_SCENARIO_KEYS = [];

function resolveReviewCaseSource(flag) {
  const source = String(flag?.source || '').toLowerCase();
  const reason = String(flag?.reason || flag?.trigger || '').toLowerCase();
  if (source.includes('detection') || reason.includes('promotional') || reason.includes('pattern')) {
    return 'Detection';
  }
  if (source.includes('system')) return 'System Signal';
  return 'System Signal';
}

function collectScenarioFlags(s) {
  if (Array.isArray(s.flags) && s.flags.length) return s.flags;
  if (s.flag) return [s.flag];
  return [];
}

export function getReviewQueueCases() {
  const rows = [];
  reviewScenarios
    .filter((s) => !REVIEW_QUEUE_EXCLUDED_SCENARIO_KEYS.includes(s.scenarioKey))
    .forEach((s) => {
      const r = s.review;
      const flags = collectScenarioFlags(s).filter((f) => {
        const st = String(f.caseStatus || f.status || '').trim();
        return st === 'New' || st === 'Active';
      });
      if (!flags.length) return;

      flags.forEach((flag) => {
        const caseId = flag.linkedCaseId || s.case?.caseId;
        if (!caseId) return;
        const caseRecord = resolveReviewCaseRecord(s, caseId) || s.case || null;
        const accountAvatar = r.business?.logo || r.reviewer?.avatar || null;
        const reviewReason = flag.reason || flag.trigger || '—';
        const caseSource = resolveReviewCaseSource(flag);
        const flagCount = null;
        const severity = flag.severity || caseRecord?.severity || s.case?.severity || 'Medium';
        const status =
          caseRecord?.status || flag.caseStatus || flag.status || s.case?.status || 'New';
        const isBusinessReply = String(flag.reviewTarget || '').includes('Business Reply');
        rows.push({
          caseId,
          contentType: isBusinessReply ? 'Business Reply' : 'Review',
          preview: r.fullText
            ? r.fullText.length > 60
              ? `${r.fullText.substring(0, 60)}…`
              : r.fullText
            : '—',
          caseSource,
          reviewReason,
          flagReason: reviewReason,
          flagCount,
          priority: severity,
          severity,
          status,
          assignedTo: caseRecord?.assignedTo || 'Unassigned',
          created: flag.createdAt || caseRecord?.created || s.case?.created,
          updated: flag.updatedAt || caseRecord?.updated || s.case?.updated,
          reviewId: r.reviewId,
          reviewRef: r.id,
          businessName: r.business?.name,
          businessId: r.business?.id,
          customerName: r.reviewer?.name,
          customerId: r.reviewer?.id,
          accountName: isBusinessReply
            ? r.business?.name || r.reviewer?.name || '—'
            : r.reviewer?.name || r.business?.name || '—',
          accountAvatar,
          flagId: flag.flagId,
          reviewTarget: flag.reviewTarget || 'Customer Review',
        });
      });
    });
  return rows;
}

export { REVIEW_QUEUE_EXCLUDED_SCENARIO_KEYS };

/** Open Flags: distinct Flags whose cases are New or Active (not Decided). */
function countOpenFlags(flags) {
  if (!flags || !flags.length) return 0;
  return flags.filter((f) => {
    const st = String(f.caseStatus || f.status || '').trim();
    return st === 'New' || st === 'Active';
  }).length;
}

/** Ensure reply records carry permanent Review Reply ID + edit window fields. */
function enrichReplyRecord(reply, reviewId) {
  if (!reply || !reply.hasReply) {
    return { hasReply: false, status: 'Not Replied' };
  }
  const postedAt = reply.timestamp || reply.postedAt || reply.repliedAt || null;
  let editUntil = reply.editUntil || null;
  if (!editUntil && postedAt) {
    const d = new Date(postedAt);
    if (!Number.isNaN(d.getTime())) {
      d.setUTCDate(d.getUTCDate() + 30);
      editUntil = d.toISOString();
    }
  }
  const digits = String(reviewId || '')
    .replace(/\D/g, '')
    .slice(-6)
    .padStart(6, '0');
  const replyId =
    reply.replyId ||
    reply.reviewReplyId ||
    (digits ? `RRP-${digits}` : `RRP-${String(Date.now()).slice(-6)}`);

  return {
    ...reply,
    hasReply: true,
    status: reply.status === 'Deleted' ? 'Deleted' : 'Replied',
    replyId,
    postedAt,
    timestamp: postedAt,
    editUntil,
    lastUpdated: reply.lastUpdated || reply.updatedAt || postedAt,
  };
}

/** Reply Status for Reviews list / record: Not Replied | Replied | Deleted */
function resolveReplyStatus(reply) {
  if (!reply || !reply.hasReply) return 'Not Replied';
  if (reply.status === 'Deleted') return 'Deleted';
  return 'Replied';
}

function normalizeInteractionType(raw) {
  const s = String(raw || '').trim();
  if (!s) return null;
  if (s === 'Quote' || s.toLowerCase().startsWith('quote')) return 'Quote';
  if (s === 'Message' || s.toLowerCase().startsWith('message')) return 'Message';
  return s;
}

function resolveInteraction(review) {
  if (review.interactionId) {
    return {
      interactionType: normalizeInteractionType(review.interactionType) || 'Quote',
      interactionId: review.interactionId,
    };
  }
  return { interactionType: null, interactionId: null };
}

function buildReviewListRow(s) {
  const r = { ...s.review };
  const flags = collectScenarioFlags(s).map((f) => ({ ...f }));
  const c = s.case;
  const reply = enrichReplyRecord(r.reply ? { ...r.reply } : { hasReply: false }, r.reviewId || r.id);

  const openFlags = countOpenFlags(flags);
  const { interactionType, interactionId } = resolveInteraction({ ...r });
  const replyStatus = resolveReplyStatus(reply);

  const flagsByRecency = [...flags].sort(
    (a, b) =>
      new Date(b.createdAt || b.updatedAt || 0) - new Date(a.createdAt || a.updatedAt || 0)
  );
  const latestFlag = flagsByRecency[0];
  const latestFlagId = latestFlag?.flagId ?? null;
  const linkedCaseId = latestFlag?.linkedCaseId || c?.caseId || null;

  const moderationCases = [];
  const seenCases = new Set();
  flags.forEach((f) => {
    if (!f.linkedCaseId || seenCases.has(f.linkedCaseId)) return;
    seenCases.add(f.linkedCaseId);
    moderationCases.push({
      caseId: f.linkedCaseId,
      contentType: 'Review',
      severity: f.severity || 'Medium',
      status: f.caseStatus || f.status || 'New',
      assignedTo: c?.assignedTo || 'Unassigned',
      created: f.createdAt,
      updated: f.updatedAt,
    });
  });
  if (c?.caseId && !seenCases.has(c.caseId)) {
    moderationCases.push(c);
  }

  return {
    ...r,
    interactionType,
    interactionId,
    editUntil:
      r.editUntil ||
      (() => {
        const posted = r.postedAt || r.submittedAt;
        if (!posted) return null;
        const d = new Date(posted);
        if (Number.isNaN(d.getTime())) return null;
        d.setUTCDate(d.getUTCDate() + 30);
        return d.toISOString();
      })(),
    flags,
    moderationCases,
    openModerationCases: openFlags,
    totalFlags: flags.length,
    openFlagsCount: openFlags,
    latestFlagId,
    linkedCaseId,
    currentReviewStatus: r.status === 'Under Review' || openFlags > 0 ? 'Under Review' : '—',
    adminNote: s.adminNote,
    publicUrl: `https://tradesposter.com/reviews/${r.reviewId || r.id}`,
    reply,
    replyStatus,
    reviewer: {
      ...r.reviewer,
      verificationStatus: r.reviewer?.verificationStatus || 'Verified',
    },
  };
}

export function getReviewsForScenarios() {
  return reviewScenarios.map(buildReviewListRow);
}

export default reviewScenarios;
